


















































































import { namespace } from 'vuex-class';
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Tooltip } from 'element-ui';
import { AcgnFormTitle } from '@/components';

const ComicAction = namespace('desk/comic').Action;

const AuthGetter = namespace('desk/auth').Getter;
const ComicGetter = namespace('desk/comic').Getter;
const CommGetter = namespace('desk/comm').Getter;

@Component({
  components: {}
})

/**
 * 菜单
 */
export default class AcgnStaticsMenu extends Vue {
  public name: string = 'AcgnStaticsMenu';

  @Prop({ default: 'index' }) public type: string; // 类型 项目：index 漫画：comic 员工：staff
  @Prop({ default: false }) public isNor: boolean; // 是否是创作方
  @Prop({ default: null }) public comicId: number | null; // 项目id (有项目id才有目标进度)

  @ComicAction private userProlist: any; // 获取项目列表

  @AuthGetter private userInfo: any;
  @CommGetter private attributeData: any; // 公共类型
  @ComicGetter private userComicList: any; // 成员项目列表

  private keyword: string = ''; // 漫画搜索名
  private isScrollInit: boolean = false;

  private get permisstionCode() {
    return this.isNor ? '7002' : '6002';
  }

  private get realComicList() {
    if (!this.userComicList.length) {
      return;
    }
    this.setComicInitScroll();

    if (!this.keyword) {
      return this.userComicList;
    }
    return this.userComicList.filter((item: any) => item.name.includes(this.keyword));
  }

  // 设置初始时，菜单滚动位置
  private setComicInitScroll() {
    if (!this.isScrollInit) {
      this.$nextTick(() => {
        const index = this.userComicList.findIndex((item: any) => item.id === this.comicId);
        (this.$refs as any).menuScroll.scrollTop = 40 * index;
      });
      this.isScrollInit = true;
    }
  }

  private created() {
    this.getData();
  }

  private getStatusName(item: any) {
    if (!this.attributeData.other_type) {
      return '';
    }
    if (item.recycle_status) {
      return '已删除';
    }
    const val = this.attributeData.other_type[7].find((type: any) => type.value === item.status);
    return val ? val.label : '';
  }

  private async getData(initPage = false) {
    const options = {
      page: 1,
      size: 999999,
      user_id: this.userInfo.id
    };
    this.userProlist(options);
  }

  private goCli(target: any) {
    let name = '';
    if (typeof target === 'string') {
      name = 'desk-statisticNorList';
      if (!this.isNor) {
        // name = target === 'index' ? 'desk-statisticList' : 'desk-statisticStaffList';
        switch (target) {
          case 'index':
            name = 'desk-statisticList';
            break;
          case 'staff':
            name = 'desk-statisticStaffList';
            break;
           case 'project':
            name = 'desk-project-all';
            break;
          default:
            name = 'desk-statisticList';
        }
      }
      this.$router.push({ name });
      return;
    }

    name = this.isNor ? 'desk-statisticNorComicList' : 'desk-statisticComicList';
    this.$router.push({ name, params: { id: target.id } });
  }
}
